export default __webpack_public_path__ + "static/media/8.b75b1a2d.png";